import { Button } from "@material-ui/core";
import React, { useEffect } from "react";
import "./QuizInstruction.css";
import Img from "./meshimage.png";
const Instruction = (props) => {
  useEffect(() => {
    document.title = "Performance Management Healthcheck | Mesh";
  }, []);
  return (
    <>
      <div style={{ margin: "30px" }}>
        <center>
          <h1>Performance Management Healthcheck</h1>
        </center>
      </div>
      <div className="instruction">
        <div className="instruction_image">
          <img style={{ width: "100%" }} src={Img} alt="mesh" />
        </div>
        <div className="instruction_data">
          <div
            style={{ fontWeight: "400", fontSize: "20px", color: "#696969" }}
          >
            <h2>
              Want to find out how effective your company’s performance
              management style is and how yours stacks compared to others?
            </h2>
            <br></br>
            <div>
              Based on multiple research sources, practices at most-renowned
              companies on performance management, and our teams’ years of
              experience working with companies of various shapes and size
              across the world; we created a quick health-check for you to
              assess maturity of your performance management system!
            </div>
            <br></br>
            <br></br>
            <div>Let’s get started!</div>
            <div>
              <Button
                style={{
                  color: "white",
                  backgroundColor: "#2ecc71",
                  padding: "10px 30px",
                  textTransform: "none",
                  marginTop: "20px",
                  marginBottom: "70px",
                  borderRadius: "20px",
                  fontFamily: "Montserrat",
                }}
                onClick={props.quiznextClicked}
              >
                Next
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Instruction;
